'use client';
import React from 'react';
import {CustomRegistration} from '@components/CustomRegistration';
import {getLeadGenerationOptions} from '@services/properties/getLeadGenerationOptions';
import {Box, Stack} from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ParallaxBlock from '@components/ParallaxBlock';
import WaldorfTeaserContainer from '../WaldorfContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import WaldorfTeaserLogo from '../WaldorfLogo';
import {Mobile} from '@components/Mobile';
import {Desktop} from '@components/Desktop';
import cn from './style.module.scss';
type Props = {
  logoImage: any;
  t: any;
  anchorId?: string;
};
export const THEWILETEASER_ID = 'Registration';
export const WaldorfLaunchRegistration = () => {
  const el = document.getElementById(THEWILETEASER_ID);
  if (el) {
    el.scrollIntoView({block: 'start', behavior: 'smooth'});
  }
};
export default function WaldorfRegistration(props: any) {
  const {t} = props;
  const [countryCode, setCountryCode] = React.useState<{}[]>([]);
  const [nationalities, setNationalities] = React.useState<{}[]>([]);
  const leadMetaRequest = React.useMemo(() => getLeadGenerationOptions(), []);
  const setLeadMetaData = async () => {
    const {countryCode, nationalities} = await leadMetaRequest.getResponse();
    setNationalities(nationalities);
    setCountryCode(countryCode);
  };
  React.useEffect(() => {
    setLeadMetaData();
    return () => leadMetaRequest.abort();
  }, []);
  return (
    <Box component='section' className={cn.waldorfRegistration}>
      <Stack className={cn.waldorfRegistrationInner} id={THEWILETEASER_ID}>
        <WaldorfTeaserContainer>
          <Box className={cn.waldorfRegistrationContainer}>
            <Box className={cn.waldorfRegistrationContainer__data}>
              <Box className={cn.waldorfRegistrationContent}>
                <ParallaxText
                  variant='h4'
                  animationType='slideInBottom'
                  animationDuration={800}>
                  {ReactHtmlParser(t['waldorfRegistrationContent'])}
                </ParallaxText>
              </Box>
              <Desktop>
                <Box className={cn.waldorfRegistrationLogo}>
                  <ParallaxBlock animationType='zoomIn' animationDuration={800}>
                    <Box className={cn.waldorfLogoElement}>
                      <WaldorfTeaserLogo logoImage={props.logoImage} />
                    </Box>
                  </ParallaxBlock>
                </Box>
              </Desktop>
            </Box>
            <Stack className={cn.waldorfRegistrationContainer__forms}>
              <ParallaxBlock
                animationType='slideInBottom'
                animationDuration={800}>
                <Box className={cn.waldorfFormsElement}>
                  <CustomRegistration
                    t={t}
                    successPopUpLink={props.successPopUpLink}
                    privacyPolicyLink={props.privacyPolicyLink}
                    termsAndConditionsLink={props.termsAndConditionsLink}
                    countryCodes={countryCode}
                    nationalities={nationalities}
                    className={cn.waldorfRegistrationWrapper}
                    listClassName={cn.waldorfRegistrationList}
                    blockClassName={cn.waldorfRegistrationBlocks}
                    inputClassName={cn.waldorfRegistrationInputs}
                    submitBlockClassName={cn.waldorfSubmitBlock}
                    submitClassName={cn.waldorfRegistrationButton}
                    authClassName={cn.waldorfRegistrationAuth}
                    marksClassName={cn.waldorfCheckMarck}
                    contentClassName={cn.waldorfSuccessContent}
                    buttonClassName={cn.waldorfSuccessButton}
                    formId={props.formId}
                    formType={props.formType}
                    projectName={props.projectName}
                    variant='modal'
                    showLogo
                  />
                </Box>
              </ParallaxBlock>
            </Stack>
            <Mobile>
              <Box className={cn.waldorfRegistrationContainer__logo}>
                <ParallaxBlock animationType='zoomIn' animationDuration={800}>
                  <Box className={cn.waldorfLogoElement}>
                    <WaldorfTeaserLogo logoImage={props.logoImage} />
                  </Box>
                </ParallaxBlock>
              </Box>
            </Mobile>
          </Box>
        </WaldorfTeaserContainer>
      </Stack>
    </Box>
  );
}
